import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";

import AssignedUser from "src/library/components/AssignedUser/AssignedUser";
import { ISupportTicket } from "src/modules/support/api/support.api";

export const supportTicketAssignedColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor, column:
  Partial<Pick<DisplayColumnDef<TData>, "id">>
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: column.id ? column.id : accessor,
    header: "Assinged User",
    enableSorting: false,
    cell: info => {
      const ticket = info.row.original as ISupportTicket;

      return (
        <AssignedUser
          rowId={ticket.id}
          user={ticket.assignedUser}
          groupName={ticket.userGroup?.name}
          justification="center"
        />
      );
    }
  } as DisplayColumnDef<TData>);
};
